/* eslint-disable no-unused-expressions */
export function parseQueryStringToObj(queryStr: string | null | undefined): {
  [key: string]: string;
} {
  const dictionary: {
    [key: string]: string;
  } = {};

  if (typeof queryStr !== 'string' || queryStr.length === 0) {
    return dictionary;
  }

  // remove the '?' from the beginning of the
  // if it exists
  let queryString = queryStr;
  if (queryStr.indexOf('?') === 0) {
    queryString = queryStr.substr(1);
  }
  if (!queryString.length) {
    return dictionary;
  }

  // Step 1: separate out each key/value pair
  const parts = queryString.split('&');

  for (let i = 0; i < parts.length; i += 1) {
    const p = parts[i];
    // Step 2: Split Key/Value pair
    const keyValuePair = p.split('=');

    // Step 3: Add Key/Value pair to Dictionary object
    const key = keyValuePair[0];
    let value = keyValuePair[1];

    // decode URI encoded string
    value && value.replace(/\+/g, '%20');
    value = decodeURIComponent(value);

    dictionary[key] = value;
  }

  // Step 4: Return Dictionary Object
  return dictionary;
}
